module.exports = __webpack_public_path__ + "static/media/ubs-profissionais.b966a72d.png";